import { DatePicker, Radio } from '@maxtropy/components';
import dayjs, { Dayjs } from 'dayjs';
import {
  TimeGranularity,
  TimeGranularityDisplay,
  TimeGranularityInitialValue,
  TimeGranularityMaxRange,
} from '../const';
import { Space } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';

export type RangeValue = [Dayjs | null, Dayjs | null] | null;

const getYearMonth = (date: Dayjs) => date.year() * 12 + date.month();

type DateSwitchProps = {
  timeGranularity: TimeGranularity;
  onTimeGranularityChange: (v: TimeGranularity, nextValue: RangeValue) => void;
  value: RangeValue;
  onValueChange: (v: RangeValue) => void;
};

const DateSwitch = ({ timeGranularity, onTimeGranularityChange, value, onValueChange }: DateSwitchProps) => {
  const disabledDate: DatePickerProps['disabledDate'] = (current, { from, type }) => {
    if (current && current > dayjs().endOf('day')) return true;
    if (from) {
      // 按小时 - 最多选择 31 天
      // 按天 - 最多选择 365 天
      // 按月 - 最多选择 36 个月
      const maxRange = TimeGranularityMaxRange[timeGranularity];
      if (TimeGranularity.MONTH === timeGranularity) {
        return (
          getYearMonth(current) < getYearMonth(from.add(-maxRange + 1, 'months')) ||
          getYearMonth(current) > getYearMonth(from.add(maxRange - 1, 'months'))
        );
      } else {
        return Math.abs(current.diff(from, 'days')) >= maxRange;
      }
    }
    return false;
  };

  return (
    <Space size={8}>
      <Radio.Group
        options={Object.entries(TimeGranularityDisplay).map(([value, label]) => ({
          label,
          value,
        }))}
        onChange={e => {
          // 设置时间颗粒度和时间
          onTimeGranularityChange(e.target.value, TimeGranularityInitialValue[e.target.value]);
        }}
        value={timeGranularity}
        optionType="button"
        buttonStyle="solid"
      />
      <DatePicker.RangePicker
        allowClear={false}
        picker={timeGranularity === TimeGranularity.MONTH ? 'month' : 'date'}
        value={value}
        disabledDate={disabledDate}
        onChange={val => {
          if (val?.[0] && val?.[1]) {
            onValueChange([
              val?.[0]?.startOf(timeGranularity === TimeGranularity.MONTH ? 'month' : 'date'),
              val?.[1]?.endOf(timeGranularity === TimeGranularity.MONTH ? 'month' : 'date'),
            ]);
          }
        }}
      />
    </Space>
  );
};

export default DateSwitch;
